module.exports = __webpack_public_path__ + "static/media/rammyWorld1.4a3d55b2.jpg";